export const config = {
    baseUrl: window.location.origin + "/" + window.location.pathname.split('/')[1],
    // baseUrl: "https://localhost:44390",
};